const photos = [
  {
    src: 'https://readdy.ai/api/search-image?query=University%20campus%20cherry%20blossom%20closeup%20with%20sunlight%20through%20pink%20petals%2C%20soft%20dreamy%20bokeh%20background%2C%20spring%20atmosphere%2C%20clean%20artistic%20composition%2C%20warm%20pastel%20colors&width=800&height=800&seq=photo-gallery-01&orientation=squarish',
    alt: '校园樱花特写 - 阳光透过粉色花瓣的梦幻画面',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Campus%20library%20reading%20room%20with%20warm%20afternoon%20sunlight%20through%20big%20windows%2C%20wooden%20tables%20and%20books%2C%20peaceful%20atmosphere%2C%20clean%20interior%20photography&width=800&height=800&seq=photo-gallery-02&orientation=squarish',
    alt: '午后图书馆阅览室的温暖光影',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Golden%20ginkgo%20leaves%20on%20campus%20path%20in%20autumn%2C%20warm%20sunlight%2C%20yellow%20leaves%20scattered%20on%20ground%2C%20nostalgic%20seasonal%20beauty%2C%20clean%20composition&width=800&height=800&seq=photo-gallery-03&orientation=squarish',
    alt: '秋日校园银杏落叶铺满小径',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Historic%20university%20building%20arched%20corridor%20with%20beautiful%20light%20and%20shadow%20patterns%2C%20classical%20architecture%2C%20warm%20cream%20tones%2C%20artistic%20photography&width=800&height=800&seq=photo-gallery-04&orientation=squarish',
    alt: '老教学楼拱形走廊的光影交错',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=University%20campus%20snow%20scene%20with%20red%20brick%20building%20contrast%2C%20fresh%20white%20snow%20on%20trees%2C%20peaceful%20winter%20atmosphere%2C%20clean%20minimal%20composition&width=800&height=800&seq=photo-gallery-05&orientation=squarish',
    alt: '冬日校园红墙白雪的静谧之美',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Students%20sitting%20on%20green%20campus%20lawn%20under%20sunlight%2C%20reading%20and%20chatting%2C%20youthful%20vibrant%20atmosphere%2C%20warm%20golden%20hour%20lighting%2C%20clean%20natural%20composition&width=800&height=800&seq=photo-gallery-06&orientation=squarish',
    alt: '校园草坪上学生们享受阳光的青春场景',
  },
];

export default function PhotoGallery() {
  return (
    <section className="w-full px-6 md:px-10 py-20 bg-background-100">
      <div className="text-center mb-12">
        <p className="text-accent-500 text-sm font-medium tracking-widest mb-2">GALLERY</p>
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900">
          摄影作品
        </h2>
        <p className="mt-3 text-foreground-500 text-sm max-w-xl mx-auto">
          用镜头定格校园最美的瞬间，每一帧都是青春的记忆
        </p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="group relative rounded-lg overflow-hidden cursor-pointer aspect-square"
          >
            <img
              src={photo.src}
              alt={photo.alt}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
              <i className="ri-zoom-in-line text-white text-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}